import RNBootSplash from "react-native-bootsplash";

export const SplashScreen = RNBootSplash;
